module.exports = __webpack_public_path__ + "img/flyingspur-blue.bf7ca83b.png";